<template>
  <div class="equity-center">

    <!-- 三单挑战 -->
    <div class="activity-card" v-if="showThreeOrderActivity">
      <div class="card-title">
        <div class="title-left">
          <div class="title">新用户专享 三单挑战</div>
          <activity-common-rule :desc="fullAmountActivityRule" btn-text="规则说明">
            <div class="rule">
              规则说明
              <span class="rule-icon"></span>
            </div>
          </activity-common-rule>
        </div>
        <div class="title-right">
          <count-down-timer :init-left-time="fullOrderActivity.remaining_seconds"></count-down-timer>
        </div>
      </div>
      <div class="card-content">

        <div class="three-order-content">
          <div class="three-order-center">
            <div class="discount-list">
              <decorative-wrap 
                class="discount-item" 
                :options="{
                  scale: fullOrderActivity.last_threshold_num === index ? 0.62 : 0.56, 
                  opacity: fullOrderActivity.last_threshold_num === index ? 1 : 0.65
                }"
                v-for="(coupon,index) in fullOrderActivity.coupon_list" 
                :key="index">
                <coupon-discount-item 
                  :current="fullOrderActivity.last_threshold_num === index" 
                  :index="index"
                  :coupon="coupon"
                >
                  <div slot="title" v-if="fullOrderActivity.last_threshold_num === index">
                    <count-down-timer :delay="1000" :init-left-time="coupon.remaining_seconds" v-slot="scope">
                      <span class="coupon-title-left-time" v-if="+scope.timeInfo.day">{{+scope.timeInfo.day}}天后过期</span>
                      <span class="coupon-title-left-time" v-else>剩{{scope.timeInfo.hour}}:{{scope.timeInfo.minute}}:{{scope.timeInfo.second}}</span>
                    </count-down-timer>
                  </div>
                </coupon-discount-item>
                <div :class="['discount-process', (fullOrderActivity.last_threshold_num > index ? 'claimed' : ''), (fullOrderActivity.last_threshold_num === index ? 'current' : '')]" slot="bottom">
                  <div class="process-icon"></div>
                  <div class="process-value opacity-65" v-if="fullOrderActivity.last_threshold_num !== index">第{{ index + 1 }}单</div>
                  <div class="process-value" v-else>已买<span class="number">{{ fullOrderActivity.last_threshold_num }}</span>单</div>
                </div>
              </decorative-wrap>
            </div>
            <div class="process-bar">
              <div class="active-bar" :style="{'width': fullOrderActivity.last_threshold_num / 3 * 100+'%' }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 满额活动 -->
    <div class="activity-card" v-if="fullAmountActivity">
      <div class="card-title">
        <div class="title-left">
          <div class="title">满额优惠</div>
          <activity-common-rule :desc="fullAmountActivity.page_config.activity_rule_desc" btn-text="规则说明">
            <div class="rule">
              规则说明
              <span class="rule-icon"></span>
            </div>
          </activity-common-rule>
        </div>
        <div class="title-right">
          <count-down-timer :end-date="fullAmountActivity.end_time"></count-down-timer>
        </div>
      </div>
      <div class="card-content">
        <div class="full-amount-content">
          <activity-receive-discount 
            :init-activity-detail="fullAmountActivity" 
            :options="{hideTimer: true}">
          </activity-receive-discount>
        </div>
        
      </div>
    </div>
    

  </div>
</template>

<script>
import couponDiscountItem from '@/components/activity/coupon-item/coupon-discount-item';
import couponCommonItem from '@/components/activity/coupon-item/coupon-common-item/coupon-common-item';
import activityReceiveDiscount from '@/components/activity/activity-receive-discount';
import countDownTimer from '@/components/activity/count-down-timer';
import activityCommonRule from '@/components/activity/activity-common-rule.vue';
import decorativeWrap from '@/components/activity/decorative-wrap';
import Http from '@/libs/http';

export default {
  components: {
    couponDiscountItem,
    couponCommonItem,
    activityReceiveDiscount,
    countDownTimer,
    activityCommonRule,
    decorativeWrap,
  },
  data() {
    return {
      fullOrderActivity: undefined,
      fullAmountActivity: undefined,
      fullAmountActivityRule: `<span style="font-weight: 600;">1、</span>新用户注册后，即可获得第一张优惠券，此后前三单每完成一单的支付，将获得一张额外优惠券，优惠券额度以实际到账为准；
<span style="font-weight: 600;">2、</span>系统发放优惠券后，优惠券将存入用户账户中，用户可在上上签办签助手小程序中查看（查看路径：“我的-我的优惠券”），请注意<span style="font-weight: 600;">在有效期内及时使用优惠券</span>；
<span style="font-weight: 600;">3、</span>如上上签在活动期间识别出用户账号为风险账号或用户存在作弊、恶意刷奖等违规行为，上上签将取消用户的活动资格，并有权撤销相关奖励，并有权在必要时追究法律责任；
<span style="font-weight: 600;">4、</span>如出现不可抗力或情势变更的情况（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、遭受严重网络攻击或因系统故障需要暂停举办的），上上签有权暂停、终止或取消本次活动，并停止发放相关优惠福利；
<span style="font-weight: 600;">5、</span>上上签可根据本活动的实际举办情况对活动规则进行变动或调整，相关改动或调整将公布在活动页面上，并于公布时即时生效。
    `,
    };
  },
  computed: {
    // 该用户是否有三单挑战活动
    showThreeOrderActivity() {
      if (!this.fullOrderActivity) return;
      // 活动是否过期 + 是否已经完成三单挑战
      return this.fullOrderActivity.remaining_seconds && !this.fullOrderActivity.is_complete;
    },
  },
  created() {
    this.getThreeOrderActivity();
  },
  methods: {
    async getThreeOrderActivity() {
      // 弹窗显示resolve,不显示reject
      // is_need_complete_coupon: 0-否 1-是（权益中心-0 弹窗-1）
      const res = await Http.post('/peer_benefits_center_query');
      this.fullOrderActivity = res.full_order_activity;
      this.fullAmountActivity = res.full_price_activity;
    },
  },
};
</script>

<style lang="less" scoped>
.equity-center {
  .activity-card {
    padding: 24px;
    .card-title {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      .title-left {
        display: flex;
        align-items: center;
        .title {
          font-weight: 600;
          color: #2F333D;
          display: flex;
          align-items: center;
          &::after {
            content: '';
            display: inline-block;
            width: 1px;
            height: 16px;
            background: #91999F;
            opacity: 0.3;
            margin-left: 12px;
          }
        }
        .rule {
          padding-left: 12px;
          color: #91999F;
          display: flex;
          align-items: center;
          .rule-icon {
            margin-left: 8px;
            width: 16px;
            height: 16px;
            background: url(../../../../assets/imgs/activity/full-amount-activity/rule-icon.png) no-repeat center;
            background-size: 100% 100%;
          }
        }
      }
      .title-right {
        
      }
    }

    .card-content {
      margin-top: 24px;
      .three-order-content {
        border-radius: 2px;
        border: 1px solid #DEE2E6;
        background: linear-gradient( 180deg, rgba(255,75,75,0.15) 0%, rgba(255,75,75,0) 40%);
        padding: 24px 0 56px 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        .three-order-center {

        }
        .discount-list {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          .discount-item {
            margin-left: 120px;
            &:first-child {
              margin-left: 0;
            }
          }
          .discount-process {
            position: absolute;
            bottom: -16px;
            left: 50%;
            transform: translate(-50%, 100%);
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 2;
            &.current {
              .process-icon {
                border: 1px solid #FF6C53;
                &::after {
                  content: '';
                  opacity: 1;
                }
              }
            }
            &.claimed {
              .process-icon {
                border: 2px solid #FFC9CD;
                background: linear-gradient( 119deg, #FF6F54 0%, #FF4448 100%);
                &::after {
                  content: '';
                  background: url(../../../../assets/imgs/activity/three-order-activity/coupon-receviced-gou.png) no-repeat center;
                  background-size: 100% 100%;
                  opacity: 1;
                }
              }
            }
            .process-icon {
              width: 24px;
              height: 24px;
              background: linear-gradient( 134deg, #FFEEF0 0%, #FEE4E6 100%);
              border: 1px solid #FFC9CD;
              border-radius: 50%;
              color: rgba(244, 51, 68, .5);
              display: flex;
              align-items: center;
              justify-content: center;
              &::after {
                content: '';
                width: 12px;
                height: 7px;
                background: url(../../../../assets/imgs/activity/three-order-activity/coupon-recevice-gou.png) no-repeat center;
                background-size: 100% 100%;
                opacity: 0.8;
              }
            }
            .process-value {
              margin-top: 8px;
              color: #2F333D;
              white-space: nowrap;
              font-size: 14px;
              &.opacity-65 {
                opacity: 0.65;
              }
              .number {
                color: #F43344;
              }
            }
          }
        }
        .process-bar {
          margin-top: 26px;
          width: 100%;
          height: 6px;
          background: rgba(255, 75, 75, .15);
          border-radius: 4px;
          position: relative;
          .active-bar {
            display: inline-block;
            position: absolute;
            background: #FF4B4B;
            border-radius: 4px;
            z-index: 0;
            width: 0%;
            height: 100%;
          }
        }

      }

      .full-amount-content {
        border-radius: 2px;
        border: 1px solid #DEE2E6;
        padding: 16px;
      }


      
    }
  }
  .equity-list {
    background: linear-gradient( 180deg, rgba(255,75,75,0.15) 0%, rgba(255,75,75,0.05) 100%);
    border-radius: 2px;
    border: 1px solid #DEE2E6;
    padding: 16px;
    .equity-card {
      padding: 24px 24px 8px 24px;
      .equity-card-title {
        color: #2F333D;
      }
      .equity-card-content {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .coupon-item {
          margin-bottom: 16px;
        }
      }
    }
  }
 
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/equity-center/equity-center.vue